import { render, staticRenderFns } from "./AdmissionsYearWeekSites.vue?vue&type=template&id=375fd70b"
import script from "./AdmissionsYearWeekSites.vue?vue&type=script&lang=js"
export * from "./AdmissionsYearWeekSites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375fd70b')) {
      api.createRecord('375fd70b', component.options)
    } else {
      api.reload('375fd70b', component.options)
    }
    module.hot.accept("./AdmissionsYearWeekSites.vue?vue&type=template&id=375fd70b", function () {
      api.rerender('375fd70b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsYearWeekSites.vue"
export default component.exports